<template>
  <div class="cb-item cb-transition__tab" :style="themeColor">
    <div class="cb-item__group">
      <div class="cb-item__sub-group">
        <h2 class="cb-item__price cb-item__sub-group--right">
          <span class="cb-item__middle" v-if="amount">
            {{ amount }}
          </span>
          <span class="cb-item__price--info" v-if="showPriceInfo && priceInfo" v-cb-html="sanitizeTags(priceInfo, [])"></span>
        </h2>
        <h2 class="cb-item__name  cb-item__sub-group--left">
          {{ name }} <span v-if="showQuantityReadOnly"><i class=" cb-item__icon-remove">&times;</i> {{isMultiDecimal ? quantityInDecimal : quantity}}</span> <span v-if="nonRecAddonTag" class="cb-label cb-label-recur" :style="backgroundColor">{{ct('non_rec_addon.tag')}}</span>
        </h2>
        <h3 class="cb-item__desc cb-mar--r-md" v-if="!isAdhocCharge && description" v-cb-html="sanitizeTags(description, ['br'])"></h3>
        <p class="cb-item__metered-desc" v-if="item.metered">&#9889; {{cmt('metered_billing_desc')}}</p>
      </div>
      <div class="cb-item__sub-group" v-if="(canShowQuantity || canShowRemove)">
        <template v-if="isMultiDecimal">
          <multi-decimal-quantity v-if="canShowQuantity" :quantity="quantityInDecimal" @input="updateQuantityInDecimal" :meta="quantityMeta" :initial-quantity="getInitialQuantity"/>
        </template>
        <template v-else>
          <quantity-template v-if="canShowQuantity" :quantity="quantity" @input="updateQuantity" :meta="quantityMeta" :initial-quantity="getInitialQuantity"/>
        </template>
        <div class="cb-item__action cb-item__remove cb-item__sub-group--inline" v-if="canShowRemove">
          <span @click="remove()" v-cb-link="'color'">{{ct('cart.remove')}}</span>
        </div>
      </div>
      <item-description :singleCart='singleCart' :item='item' :currencyCode='currencyCode'></item-description>
    </div>
  </div>
</template>
<script type="text/javascript">
import CartHelper from '@/utils/cart-helper'
import TierHelper from '@/utils/lineitem-tier-helper'
import Quantity from "@/components/modules/hosted-pages/Quantity"
import MultiDecimalQuantity from "@/components/modules/hosted-pages/MultiDecimalQuantity"
import ItemDescription from "@/components/modules/hosted-pages/ItemDescription"
import currencyFilter, { mdCurrencyFilter } from "@/filters/currency"
import MultiDecimalHelper from "@/utils/multi-decimal"
import {
  mapGetters
} from 'vuex'
export default {
  props: ['item', 'singleCart', 'readonly', 'currencyCode', 'useItem', 'singleItem'],
  components: {
    'quantity-template': Quantity,
    'multi-decimal-quantity': MultiDecimalQuantity,
    'item-description': ItemDescription
  },
  methods: {
    ...CartHelper,
    updateQuantity(value) {
      if (value != this.quantity) {
        this.$store.dispatch('set_loader', true);
        var q = this.quantity;
        this.$store.dispatch('update_quantity', {
          item: this.item,
          value: value
        }).then(() => {
          this.$store.dispatch('set_loader', false);
        }).catch((error) => {
          // TODO show error
          //revisit logic
          // if(error._source.error_code == "amount_overflow" || error._source.error_code == "wrong_format"){
            this.$store.dispatch('update_quantity', {
              item: this.item,
              value: q
            })
          // }
          this.$store.dispatch('set_loader', false);
          this._displayErrorMessage(error,false);
          logger.e(error);
        });
      }
    },
    updateQuantityInDecimal(value) {
      // TODO DRY
      if (value != this.quantity_in_decimal) {
        this.$store.dispatch('set_loader', true);
        var q = this.quantity_in_decimal;
        this.$store.dispatch('update_quantity_in_decimal', {
          item: this.item,
          value: value
        }).then(() => {
          this.$store.dispatch('set_loader', false);
        }).catch((error) => {
          this.$store.dispatch('update_quantity_in_decimal', {
            item: this.item,
            value: q
          })
          this.$store.dispatch('set_loader', false);
          this._displayErrorMessage(error,false);
          logger.e(error);
        });
      }
    },
    _displayErrorMessage(error, skipNotificationSetting) {
      if (!skipNotificationSetting) {
        this.$store.dispatch('set_current_notification', {
          type: 'error',
          message: error.message
        });
      }
    },
    remove() {
      this.$store.dispatch('remove_item', this.item);
    },
    sanitizeTags(content, allowedTags){
      return {
        text: content,
        tags: allowedTags,
        attrs: {}
      }
    }
  },
  computed: {
    ...mapGetters(['ui_config', 'is_cart_with_estimate', 'get_line_item_by_entity_id']),
    isMultiDecimal() {
      return MultiDecimalHelper.isMultiDecimal(this.item)
    },
    lineItem() {
      return this.useItem ? undefined : this.item.lineItem;
    },
    amount() {
      const amt = this.lineItem ? this.lineItem.amount :
        this.item.metered ? '0' : this.item.amount;
      if(amt) return mdCurrencyFilter(amt, this.currencyCode)
    },
    amountInDecimal() {
      const mdAmount = this.lineItem ? this.lineItem.amount_in_decimal : this.item.amount_in_decimal
      return mdCurrencyFilter(mdAmount, this.currencyCode)
    },
    unitAmount() {
      if(this.isMultiDecimal)
        return this.lineItem ? this.lineItem.unit_amount_in_decimal : this.item.unit_amount_in_decimal;
      return this.lineItem ? this.lineItem.unit_amount : this.item.unit_amount;
    },
    description() {
      if(this.singleCart) {
        return this.item.details && this.item.details.description;
      }
      return this.$store.getters.can_show_product_description && this.item.details && this.item.details.description;
    },
    isAdhocCharge() {
      return this.item.entity_type == "adhoc" && this.item.details && this.item.details.description;
    },
    name() {
      return this.lineItem ? this.lineItem.description : (this.item.details && (this.item.details.invoice_name || this.item.details.name || this.item.details.description));
    },
    /*
        - useItem - control variable to whether show/hide line item in cart
        - singleItem - if cart has only one item.
        - charge_type - recurring / non-recurring ( present in all addon involved checkout flows)
        - charge_on_option - applicable for event_based_addons only and shows up only via addon_applicablity feature
        - Conditions to not show the tag:
          - If item is null, return false
          - If cart has only one item, return false
          - If line item is set to not visible, return false
          - If one time checkout, return false
          - default case, return false
        - Conditions to show the tag:
          - If item is non recurring item and type of addon or event based addons, return true.
     */
    nonRecAddonTag() {
      if (this.item == null || this.singleItem || this.$store.getters.is_checkout_one_time) return false;
      if (this.useItem && (this.item.charge_type == "non_recurring" || this.item.charge_on_option == "on_event")) {
        return true;
      }
      return false;
    },
    quantity() {
      return parseInt(this.item.quantity || 0);
    },
    quantityInDecimal() {
      return this.item.quantity_in_decimal
    },
    chargedQuantity() {
      const lineItem = this.lineItem || this.get_line_item_by_entity_id(this.item.id)
      const chargedQty =
        (lineItem && lineItem.quantity_in_decimal) ||
        (this.lineItem && this.lineItem.quantity) ||
        (lineItem && lineItem.quantity) ||
        this.item.charged_quantity_in_decimal ||
        this.item.charged_quantity;
      var output = this.lineItem
        ? this.lineItem.quantity
        : this.quantity - this.freeQuantity;
      if(chargedQty) return chargedQty;
      else if(parseInt(output) > 1) return output; // TODO REMOVE THIS LINE AFTER MULTI DECIMAL RELEASE
      return;
    },
    freeQuantity() {
      return MultiDecimalHelper.getFreeQuantity(this.item);
    },
    quantityMeta() {
      let qtyMeta = this.ui_config["hp_v3.quantity.custom_selection"] && (this.item.quantity_meta_overrides || (this.item.details.meta_data && this.item.details.meta_data.quantity_meta));
      if(!qtyMeta && !this.isMultiDecimal && window.isMobile) {
        qtyMeta = {
          type: "range",
          min: 1,
          max: 99999,
          step: 1
        }
      }
      return qtyMeta;
    },
    getInitialQuantity() {
      if(this.quantityMeta && this.quantityMeta.allow_only_upgrade) {
          return this.item.initialQuantity || 0;
      } else {
        return MultiDecimalHelper.isMultiDecimal(this.item) ? "0.00" : 0;
      }
    },
    canShowQuantity() {
      return !this.readonly && CartHelper.canShowQuantity(this.item, this.$store.getters);
    },
    canShowRemove() {
      return !this.readonly && !this.singleItem && CartHelper.canRemove(this.item, this.$store.getters);
    },
    showQuantityReadOnly() {
      return !this.singleCart && this.quantity > 1 && !this.canShowQuantity;
    },
    priceInfo() {
      let helper = TierHelper.getTierConstructor(this.item, this.currencyCode, this.$store.getters);
      let info = helper.constructPriceInfo();
      if(!info && this.chargedQuantity) {
        info = helper.quantityDesc(
          this.unitAmount,
          this.chargedQuantity, false);
      }
      if(info) return "&#40;" + info + "&#41;"
    },
    /**
     * Hide price info for either of the conditions
     * 1. pricing model is flat fee
     * 2. when quantity is singular for single item in cart
     */
    showPriceInfo() {
      // CHKOUTENGG-20312 : For multi decimal, irrespective of pricing model, 
      // price x quantity breakdown to be shown
      if(this.singleCart && this.isMultiDecimal) return true;
      if (this.item && this.item.pricing_model === 'flat_fee') {
        return false
      }
      if(this.singleCart) {
        return !!(this.chargedQuantity && !(parseInt(this.chargedQuantity) == 1))
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.cb-label-recur{
  margin: 3px;
}
.cb-item__desc {
  clear: both;
  word-break: break-word
}
</style>
